import {VehicleDataProvider} from "../../../../api/generated";

export const KEYLOOP_PIPELINE_SEARCH_PROVIDER = "KEYLOOP_PIPELINE_SEARCH" as VehicleDataProvider;
